"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initNavMob = initNavMob;
function initNavMob() {
    const $navMob = document.getElementById('navMob');
    const $navMobItems = document.getElementsByClassName('nav-mob__item');
    const NAVMOB_OPENED = 'nav-mob--opened';
    const NAVMOB_ITEM_ACTIVE = 'nav-mob__item--active';
    let activeNavItem = null;
    for (const $navMobItem of $navMobItems) {
        $navMobItem.addEventListener('click', function (e) {
            $navMob.classList.add(NAVMOB_OPENED);
            if (activeNavItem)
                activeNavItem.classList.remove(NAVMOB_ITEM_ACTIVE);
            activeNavItem = $navMobItem;
            $navMobItem.classList.add(NAVMOB_ITEM_ACTIVE);
            window.modal.close();
            if ($navMobItem.hasAttribute('data-nav-mob-open')) {
                window.modal.open($navMobItem.getAttribute('data-nav-mob-open'));
                document.documentElement.classList.add('nav-mob-opened');
            }
        });
    }
    window.addEventListener('hystmodal-closed', function ( /* e: CustomEvent */) {
        document.documentElement.classList.remove('nav-mob-opened');
    });
}
